var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSwap = function SvgSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillOpacity: 0.85,
    d: "M3.188 12.938h1.49a.19.19 0 0 0 .188-.188V6.766h12.389v1.702q0 .069.042.122a.194.194 0 0 0 .274.033l3.359-2.637c.1-.117.084-.241 0-.31L17.57 3.043a.198.198 0 0 0-.319.155v1.701H4.68c-.925 0-1.68.755-1.68 1.683v6.169c0 .103.084.188.188.188m17.625-1.876h-1.491a.19.19 0 0 0-.188.188v5.984H6.745v-1.702a.2.2 0 0 0-.042-.122.194.194 0 0 0-.274-.033L3.07 18.014c-.1.117-.084.242 0 .31l3.359 2.634a.198.198 0 0 0 .319-.155v-1.701h12.576c.926 0 1.68-.755 1.68-1.683V11.25a.195.195 0 0 0-.192-.187"
  })));
};
export default SvgSwap;